var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDiscord = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.044 4.992c-2.292-1.715-4.488-1.667-4.488-1.667l-.224.256c2.725.818 3.99 2.02 3.99 2.02-3.897-2.147-8.863-2.131-12.917 0 0 0 1.314-1.267 4.199-2.084l-.16-.192s-2.18-.048-4.488 1.666c0 0-2.308 4.151-2.308 9.264 0 0 1.347 2.308 4.889 2.42 0 0 .593-.705 1.073-1.314-2.035-.609-2.804-1.875-2.804-1.875 1.278.8 2.571 1.301 4.183 1.619 2.621.54 5.882-.015 8.318-1.619 0 0-.801 1.298-2.901 1.891.48.593 1.058 1.282 1.058 1.282 3.542-.112 4.888-2.42 4.888-2.404 0-5.112-2.308-9.263-2.308-9.263ZM7.011 12.765c-.898 0-1.635-.786-1.635-1.763.066-2.342 3.22-2.334 3.27 0 0 .977-.722 1.763-1.635 1.763Zm5.85 0c-.898 0-1.635-.786-1.635-1.763.072-2.337 3.187-2.338 3.27 0 0 .977-.722 1.763-1.635 1.763Z"
  })));
};
export { SvgDiscord as ReactComponent };